import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SerieOverviewItem } from '@core/models/serie-overview-item';

@Component({
	selector: 'kwo-serie-item',
	standalone: true,
	templateUrl: './serie-item.component.html',
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SerieItemComponent {

	@Input() serie!: SerieOverviewItem;

	@Output() serieClick = new EventEmitter<string>();

	goToSerie() {
		this.serieClick.emit(this.serie.slug);
	}
} 